import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { getTranslation } from "../services/translations";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./AboutPage.css";

const AboutPage = () => {
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);

  const values = [
    {
      key: "valueExcellence",
      descKey: "valueExcellenceDesc",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="32" height="32">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
        </svg>
      ),
    },
    {
      key: "valueCompassion",
      descKey: "valueCompassionDesc",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="32" height="32">
          <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>
        </svg>
      ),
    },
    {
      key: "valueInnovation",
      descKey: "valueInnovationDesc",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="32" height="32">
          <circle cx="12" cy="12" r="10"/>
          <line x1="12" y1="8" x2="12" y2="12"/>
          <line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
      ),
    },
    {
      key: "valueIntegrity",
      descKey: "valueIntegrityDesc",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="32" height="32">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
        </svg>
      ),
    },
  ];

  return (
    <div className="about-page nb-page-offset">
      <Navbar />
      {/* Hero Banner */}
      <section className="about-hero">
        <div className="about-hero-overlay" />
        <div className="about-hero-content">
          <div className="about-hero-eyebrow">{t("aboutUs")}</div>
          <h1 className="about-hero-title">{t("aboutPageTitle")}</h1>
          <p className="about-hero-subtitle">{t("aboutPageSubtitle")}</p>
          <div className="about-hero-breadcrumb">
            <Link to="/" className="breadcrumb-link">{t("home")}</Link>
            <span className="breadcrumb-sep">›</span>
            <span>{t("aboutUs")}</span>
          </div>
        </div>
      </section>

      {/* Overview Section */}
      <section className="about-overview">
        <div className="about-overview-inner">
          <div className="about-overview-img-col">
            <div className="about-overview-img-frame">
              <img
                src={`${process.env.PUBLIC_URL}/dr.png`}
                alt="Dr. Ashok Kumar"
                className="about-overview-img"
              />
              <div className="about-overview-badge">
                <span className="aob-num">15+</span>
                <span className="aob-lbl">{t("yearsOfExcellence")}</span>
              </div>
            </div>
          </div>
          <div className="about-overview-text">
            <div className="about-eyebrow">{t("ourStory")}</div>
            <h2 className="about-section-title">
              {t("trustedNameTitle")}<br />
              <span className="about-title-accent">{t("gastroCareSub")}</span>
            </h2>
            <p className="about-para">{t("aboutPara1")}</p>
            <p className="about-para">{t("aboutPara2")}</p>
            <div className="about-overview-stats">
              <div className="aos-item">
                <span className="aos-num">15+</span>
                <span className="aos-lbl">{t("yearsExperienceLbl")}</span>
              </div>
              <div className="aos-div" />
              <div className="aos-item">
                <span className="aos-num">1L+</span>
                <span className="aos-lbl">{t("patientsTreatedLbl")}</span>
              </div>
              <div className="aos-div" />
              <div className="aos-item">
                <span className="aos-num">24/7</span>
                <span className="aos-lbl">{t("emergencyCareLbl")}</span>
              </div>
            </div>
            <a href="tel:+919996504991">
              <button className="about-btn-primary">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
                  <rect x="3" y="4" width="18" height="18" rx="2"/>
                  <line x1="16" y1="2" x2="16" y2="6"/>
                  <line x1="8" y1="2" x2="8" y2="6"/>
                  <line x1="3" y1="10" x2="21" y2="10"/>
                </svg>
                {t("bookAppointment")}
              </button>
            </a>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="about-mv-section" id="mission">
        <div className="about-mv-inner">
          <div className="about-section-header">
            <div className="about-eyebrow">{t("missionVisionTitle")}</div>
            <h2 className="about-section-title">{t("missionVisionTitle")}</h2>
            <p className="about-section-subtitle">{t("missionVisionSubtitle")}</p>
          </div>
          <div className="about-mv-cards">
            <div className="about-mv-card about-mv-mission">
              <div className="about-mv-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" width="32" height="32">
                  <circle cx="12" cy="12" r="10"/>
                  <circle cx="12" cy="12" r="6"/>
                  <circle cx="12" cy="12" r="2"/>
                </svg>
              </div>
              <h3>{t("missionTitle")}</h3>
              <p>{t("missionText")}</p>
            </div>
            <div className="about-mv-card about-mv-vision">
              <div className="about-mv-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" width="32" height="32">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
              </div>
              <h3>{t("visionTitle")}</h3>
              <p>{t("visionText")}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="about-values-section">
        <div className="about-values-inner">
          <div className="about-section-header">
            <div className="about-eyebrow">{t("ourValuesEyebrow")}</div>
            <h2 className="about-section-title">{t("whatWeStandFor")}</h2>
          </div>
          <div className="about-values-grid">
            {values.map((v, i) => (
              <div key={i} className="about-value-card">
                <div className="about-value-icon">{v.icon}</div>
                <h3>{t(v.key)}</h3>
                <p>{t(v.descKey)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Director's Message — moved to /director-message page */}

      {/* CTA */}
      <section className="about-cta-section">
        <div className="about-cta-inner">
          <h2>{t("readyWorldClassCare")}</h2>
          <p>{t("bookConsultationToday")}</p>
          <div className="about-cta-btns">
            <a href="tel:+919996504991">
              <button className="about-btn-primary">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
                  <rect x="3" y="4" width="18" height="18" rx="2"/>
                  <line x1="16" y1="2" x2="16" y2="6"/>
                  <line x1="8" y1="2" x2="8" y2="6"/>
                  <line x1="3" y1="10" x2="21" y2="10"/>
                </svg>
                {t("bookAppointment")}
              </button>
            </a>
            <a href="tel:+919996504991">
              <button className="about-btn-outline">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012 1h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
                </svg>
                {t("callNowBtn")}
              </button>
            </a>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default AboutPage;
